export default __webpack_public_path__ + "static/media/transfer1.51cbbb87.svg";